import { faFileArrowDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, css, styled } from '@mui/material';

export function DownloadButton({
  children,
  onClick,
}: Readonly<{ children: React.ReactNode; href?: string; onClick?: () => void }>) {
  return (
    <StyledButton startIcon={<FontAwesomeIcon icon={faFileArrowDown} />} size="medium" onClick={onClick}>
      {children}
    </StyledButton>
  );
}

const StyledButton = styled(Button)`
  ${({ theme }) => css`
    font-size: ${theme.typography.body2.fontSize};
    font-weight: ${theme.typography.h1.fontWeight};
    background-color: ${theme.palette.primary.dark} !important;
    color: ${theme.palette.primary.contrastText} !important;
    padding-left: 1rem;
    padding-right: 1rem;
  `};
  text-transform: unset;
  & .MuiButton-startIcon {
    margin-right: 1rem;
  }
  & .MuiButton-startIcon > *:nth-of-type(1) {
    // Size of the end icon
    font-size: 1.3rem;
  }
`;
